import React, { useState, useLayoutEffect } from "react";
import Footer from "../../components/Footer";
import Nav from "../../components/nav/Nav";
//import ContactComponent from "../../components/contact/Contact";
import ContactAuth from "../../components/contact/ContactAuth";
import { useRouteMatch } from "react-router-dom";
import { useMobileCheck } from "../../utils/mobile";
import MobileContactComponent from "../mobile/Contact";
import CustomerFaq from "../../components/contact/CustomerFaq";

// @desc. 20240611 캘리스코 요청으로 인하여 고객소통 페이지 리뉴얼
/*function DesktopContactComponent({ match }) {
  return (
    <>
      <Nav />
      {/!*<ContactComponent />*!/}
      <ContactAuth />
      <Footer />
    </>
  );
}*/


function DesktopContactComponent({ match }) {
    return (
        <>
            <Nav />
            {/*<ContactComponent />*/}
            <CustomerFaq />
            <Footer />
        </>
    );
}

function Contact() {
  const [width, setWidth] = useState(window.innerWidth);
  useLayoutEffect(() => {
    window.addEventListener("resize", (e) => {
      setWidth(e.target.innerWidth);
    });

    return () => {
      window.addEventListener("resize", (e) => {
        setWidth(e.target.innerWidth);
      });
    };
  }, []);

  const match = useRouteMatch();
  return useMobileCheck(width) ? (
    <DesktopContactComponent match={match} />
  ) : (
    <MobileContactComponent match={match} />
  );
}

export default Contact;
